import React, { useCallback, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  EditInfoButton,
  FieldDealerName,
  FieldDescription,
  FieldGroup,
  FieldInput,
  FieldName,
  FormContainer,
  ModalBoxContentWrapper,
  ModalFieldTextArea,
  ModalHeader,
  ModalOuterBox,
  ModalOuterBoxContainer,
  ModalTextFieldGroup,
  StyledSubTitle
} from '../Styles';
import RetailToolsEditModal from '../RetailToolsEditModal';
import TRToast from '../../../_shared/helpers/TRToast';
import Alert from '../../../_shared/components/Alert';
import mixpanelConfig from '../../../_shared/constants/mixpanelConfig';
import SettingsService from '../../../services/SettingsService';
import MixpanelService from '../../../services/MixpanelService';

const RetailToolsTiah = ({
  testId,
  isOmp,
  companyName,
  updateDealerData,
  heading,
  greeting,
  dealerData
}) => {
  const [dealerMetadata, setDealerMetadata] = useState(dealerData);
  const [showModal, setShowModal] = useState(false);
  const [currentCustomizationData, setCurrentCustomizationData] = useState(
    dealerData
  );
  const settingsService = SettingsService.get();
  const mixpanelService = MixpanelService.get();

  function toggleShowModal() {
    setShowModal(!showModal);
  }

  const handleBlur = (e, placeholderText) => {
    const { value } = e.target;
    if (
      (value === '' ||
        value === null ||
        value === undefined ||
        value.trim().length === 0) &&
      placeholderText
    ) {
      e.target.value = placeholderText;
    }
  };
  const handleInputFieldChange = e => {
    const { value, id } = e.currentTarget;
    setDealerMetadata(updatedDealerMetadata => ({
      ...updatedDealerMetadata,
      tiah: {
        ...updatedDealerMetadata?.tiah,
        [id]: value
      }
    }));
  };
  const handleTiahSave = useCallback(async () => {
    const retailTiahProperties = ['greeting', 'heading'];

    const requestBody = dealerMetadata;

    const modifiedFields = {
      heading: false,
      greeting: false
    };

    retailTiahProperties.forEach(property => {
      if (
        requestBody?.tiah?.[property] !==
        currentCustomizationData?.tiah?.[property]
      ) {
        modifiedFields[property] = true;
      }
    });

    const updateResponse = await settingsService.updateDealerRetailInfo(
      requestBody
    );

    if (updateResponse?.isError) {
      setDealerMetadata(dealerData);
      TRToast(
        <Alert
          variant="error"
          messages={[updateResponse?.errorMessage]}
          isOmp={isOmp}
        />
      );
    } else {
      setCurrentCustomizationData(dealerMetadata);
      updateDealerData({ ...dealerMetadata });
      mixpanelService.track(
        mixpanelConfig.names.retailSettingsFieldsUpdated,
        modifiedFields
      );
      TRToast(
        <Alert
          variant="success"
          messages={[
            <FormattedMessage id="retail.tools.setting.confirmation" />
          ]}
          isOmp={isOmp}
        />
      );
    }
  }, [
    currentCustomizationData,
    dealerData,
    dealerMetadata,
    isOmp,
    mixpanelService,
    settingsService,
    updateDealerData
  ]);
  return (
    <React.Fragment key="tiah">
      <ModalOuterBox isOmp={isOmp}>
        <ModalBoxContentWrapper>
          <ModalOuterBoxContainer>
            <StyledSubTitle>
              <FormattedMessage id="retail.tools.setting.tiah.heading" />
              <FieldDealerName>{companyName}</FieldDealerName>
            </StyledSubTitle>
            <FieldDescription>
              <FormattedMessage id="retail.tools.setting.tiah.description" />
            </FieldDescription>
            <>
              <FieldGroup>{heading.displayName}</FieldGroup>
              <FieldDescription
                variant={
                  dealerMetadata?.tiah?.heading ? 'value' : 'placeholder'
                }
                data-testid={`${testId}-heading`}
                id={`${testId}-heading`}
              >
                {dealerMetadata?.tiah?.heading
                  ? dealerMetadata.tiah.heading
                  : heading?.placeholder}
              </FieldDescription>
              <FieldGroup>{greeting.displayName}</FieldGroup>
              <FieldDescription
                variant={
                  dealerMetadata?.tiah?.greeting ? 'value' : 'placeholder'
                }
                data-testid={`${testId}-greeting`}
                id={`${testId}-greeting`}
              >
                {dealerMetadata?.tiah?.greeting
                  ? dealerMetadata.tiah.greeting
                  : greeting?.placeholder}
              </FieldDescription>
            </>
            <EditInfoButton
              testId={`${testId}-tiah`}
              onClick={() => toggleShowModal()}
            >
              <FormattedMessage id="list.filters.edit.details" />
            </EditInfoButton>
          </ModalOuterBoxContainer>
        </ModalBoxContentWrapper>
      </ModalOuterBox>
      <RetailToolsEditModal
        testId={`${testId}-uploadModal-tiah`}
        isModalOpen={showModal}
        isOmp={isOmp}
        closeHandler={() => {
          setShowModal(false);
          setDealerMetadata(currentCustomizationData);
        }}
        saveHandler={async () => {
          await handleTiahSave();
          setShowModal(false);
        }}
        disableSaveCondition={false}
      >
        <ModalHeader>
          <span>
            <FormattedMessage id="retail.tools.setting.tiah.heading.for" />
            {` ${companyName}`}
          </span>
        </ModalHeader>
        <FormContainer variant="modal">
          <ModalTextFieldGroup key={heading.displayName}>
            <FieldName>
              {heading.displayName}
              <FieldInput
                id="heading"
                data-testid={`${testId}-heading`}
                variant="modal"
                ref={heading.ref}
                type={heading.type}
                maxLength={heading.limit}
                defaultValue={dealerMetadata?.tiah?.heading}
                placeholder={heading.placeholder}
                onBlur={e => handleBlur(e, heading.placeholder)}
                onChange={e => handleInputFieldChange(e)}
              />
            </FieldName>
          </ModalTextFieldGroup>
          <ModalTextFieldGroup key={greeting.displayName}>
            <FieldName>
              {greeting.displayName}
              <ModalFieldTextArea
                data-testid={`${testId}-greeting-inputField`}
                id="greeting"
                ref={greeting.ref}
                rows="2"
                cols="55"
                wrap="soft"
                defaultValue={dealerMetadata?.tiah?.greeting}
                placeholder={greeting.placeholder}
                maxLength={greeting}
                onBlur={e => handleBlur(e, greeting.placeholder)}
                onChange={e => handleInputFieldChange(e)}
              />
            </FieldName>
          </ModalTextFieldGroup>
        </FormContainer>
      </RetailToolsEditModal>
    </React.Fragment>
  );
};
export default RetailToolsTiah;
